import React from "react";
import { motion } from "framer-motion";

export default function Gallery({ items }) {
    if (!items || items.length === 0) return null;

    // Editorial layout: alternating tall/wide clipped frames
    const shape = (i) => {
        const patterns = [
            "aspect-[4/5]",
            "aspect-[16/11] md:col-span-2",
            "aspect-[4/5]",
            "aspect-[4/5]",
            "aspect-[16/11] md:col-span-2",
            "aspect-[4/5]",
        ];
        return patterns[i % patterns.length];
    };

    return (
        <section
            id="work"
            data-testid="gallery-section"
            className="relative bg-ink-800 py-24 md:py-36 border-y border-white/10"
        >
            <div className="mx-auto max-w-[1400px] px-5 md:px-10">
                <div className="grid grid-cols-12 gap-6 mb-14 md:mb-20 items-end">
                    <div className="col-span-12 lg:col-span-8">
                        <div className="font-mono-label text-lime-signal mb-4">04 — Recent Work</div>
                        <h2 className="font-display uppercase leading-[0.9] text-5xl md:text-7xl lg:text-8xl">
                            <span className="text-white">Real yards.</span>
                            <br />
                            <span className="text-stroke-white">Real trucks.</span>
                            <br />
                            <span className="text-lime-signal">Real crew.</span>
                        </h2>
                    </div>
                    <div className="col-span-12 lg:col-span-4 lg:text-right">
                        <p className="font-mono-label text-white/50">{items.length} projects · North AL</p>
                    </div>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
                    {items.map((img, i) => (
                        <motion.figure
                            key={img.image_id}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.8, delay: (i % 6) * 0.06, ease: [0.19, 1, 0.22, 1] }}
                            data-testid={`gallery-item-${i}`}
                            className={`relative overflow-hidden group border border-white/10 ${shape(i)}`}
                        >
                            <img
                                src={img.url}
                                alt={img.caption || `Project ${i + 1}`}
                                loading="lazy"
                                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105 grayscale group-hover:grayscale-0"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-ink-900/70 via-transparent to-transparent" />
                            <figcaption className="absolute left-4 bottom-4 right-4 flex items-center justify-between font-mono-label text-white/80">
                                <span>{String(i + 1).padStart(2, "0")}</span>
                                {img.caption && <span className="text-right">{img.caption}</span>}
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
